<template>
  <h1 class="budget">Monthly budget: $537 /month</h1>
  <h2 class="devices">Your Devices:</h2>
  <div class="grid">
    <div v-for="(item) in products" :key="item.id">
      <MyDevice :imgPath="item.path" :name="item.name" :price="item.price" :type="item.type" :rent="item.rent">
      </MyDevice>
    </div>
  </div>
  <h2 class="carbon-title">Your Carbon Footprint:</h2>
  <div class="carbon">
    <p class="saving">You are saving a total of</p>
    <div class="row">
      <p class="kilos">1462</p>
      <p class="co">&ThinSpace; kg of CO2</p>
      <img class="leaf" src="../assets/leaf.svg" alt="">
    </div>
  </div>
  <div class="trees">
    <p class="saving">Thats the equivalent of</p>
    <div class="row">
      <p class="kilos">5</p>
      <p class="co">&ThickSpace; trees</p>
    </div>
    <div class="row">
      <img class="tree" src="../assets/tree.svg" alt="">
      <img class="tree" src="../assets/tree.svg" alt="">
      <img class="tree" src="../assets/tree.svg" alt="">
      <img class="tree" src="../assets/tree.svg" alt="">
      <img class="tree" src="../assets/tree.svg" alt="">
    </div>
  </div>
</template>

<script>
import MyDevice from '../components/MyDevice';

export default {
  name: 'ProfilePage',
  components: {
    MyDevice
  },
  props: {
  },
  data() {
    return {
      products: [
        { id: 0, name: "IdeaPad 3i Gen 7", path: "/laptop1.png", price: 127, type: 0, rent: "80%" },
        { id: 2, name: "Monitor", path: "/monitor.png", price: 20, type: 2, rent: "20%" },
        { id: 3, name: "Desktop", path: "/desktop.png", price: 278, type: 1, rent: "60%" },
      ],
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style scoped>
.carbon-title {
  margin-top: 10%;
  margin-left: 5%;
}

.grid {
  margin-top: 1em;
  margin-left: 4%;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  height: 132px;
}

.devices {
  margin-left: 5%;
  margin-bottom: 0;
}

.budget {
  margin-top: 2em;
  margin-left: 5%;
}

.carbon {
  background-color: rgb(81, 201, 131);
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
  border-radius: 1em;
  margin-left: 5%;
  width: 20%;
}

.trees {
  background-color: rgb(255, 255, 255);
  color: black;
  box-shadow: 1px 1px 11px 9px rgba(0, 0, 0, 0.12);
  -webkit-box-shadow: 1px 1px 11px 9px rgba(0, 0, 0, 0.12);
  -moz-box-shadow: 1px 1px 11px 9px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
  border-radius: 1em;
  margin-left: 5%;
  margin-top: 2em;
  width: 20%;
}

.row {
    display: flex;
    align-items: center
}

.leaf {
  width: 20px;
  height: auto;
  margin-left: 10px;
}

.tree {
  width: 30px;
  height: auto;
  margin-left: 5px;
}

.kilos {
  font-size: 40px;
  margin: 0;
  font-weight: 900;
}

.saving {
  margin: 0;
  font-weight: 600;
}

.co {
  font-weight: 600;
}
</style>
